import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../utils/pagination-params';

export const TeachersService = {

    getTeachers(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/settings/teachers`);
        return HTTP.get(url);
    },

    getAllTeachers(schoolId) {
        return HTTP.get(`schools/${schoolId}/settings/teachers/all-active`);
    },

    getTeacher(schoolId, teacherId) {
        return HTTP.get(`schools/${schoolId}/settings/teachers/${teacherId}`);
    },

    addTeacher(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/settings/teachers`, form);
    },

    addTeachersBulk(schoolId, file) {
        const formData = new FormData();
        formData.append('teachers-file', file);
        const headers = {'Content-Type': 'multipart/form-data'};
        return HTTP.post(`schools/${schoolId}/settings/teachers/csv-import`, formData, { headers });
    },

    editTeacher(schoolId, teacherId, form) {
        return HTTP.patch(`schools/${schoolId}/settings/teachers/${teacherId}`, form);
    },

    deleteTeacher(schoolId, teacherId) {
        return HTTP.delete(`schools/${schoolId}/settings/teachers/${teacherId}`);
    },

    deleteMultipleTeachers(schoolId, teacherIds) {
        return HTTP.delete(`schools/${schoolId}/settings/teachers/?teacherIds=${teacherIds}`);
    },

    migrateChildren(schoolId, form) {
        return HTTP.put(`schools/${schoolId}/settings/teachers`, form);
    },

    toggleTeacherStatus(schoolId, teacherId) {
        return HTTP.patch(`schools/${schoolId}/settings/teachers/${teacherId}/status`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/teachers.service.js